// NPM imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Input } from "@revvsales/components";

import { GRID } from "../../constants";
import PriceMatrixRow from "../PriceMatrixRow";
import PricingPreview from "../PricingPreview";

// Destructuring
const { PRICING_METHODS, PRICING_METHODS_LABELS } = GRID;

// Declarations
const DEFAULT_MIN_QTY = 0;
const DEFAULT_MAX_QTY = 1000000000000000000000;
class AgGridPriceMatrix extends Component {
  static pricingPreviewState = null;

  state = {
    errMsg: "",
  };

  _onChange = state => {
    AgGridPriceMatrix.pricingPreviewState = state;
  };

  _onSubmit = () => {
    if (
      AgGridPriceMatrix.pricingPreviewState &&
      AgGridPriceMatrix.pricingPreviewState.units !== ""
    ) {
      const { type, range } = this.props.data;
      const { unitPrice, units } = AgGridPriceMatrix.pricingPreviewState;
      const MIN_QTY = this.props.minQty || DEFAULT_MIN_QTY;
      const MAX_QTY = range[range.length - 1].max || DEFAULT_MAX_QTY;
      if (units >= MIN_QTY && units <= MAX_QTY) {
        // For Tier & Volume the basePrice should not be multiplied by qty
        if (
          type === PRICING_METHODS.TIER_PRICING ||
          type === PRICING_METHODS.VOLUME_PRICING
        ) {
          AgGridPriceMatrix.pricingPreviewState.price = JSON.parse(unitPrice);
        }
        this.props.onSave(AgGridPriceMatrix.pricingPreviewState);
      } else {
        const errMsg =
          units >= MIN_QTY
            ? `Enter a value less than ${MAX_QTY}`
            : `Enter a value greater than ${MIN_QTY}`;
        this.setState({ errMsg });
      }
    } else {
      this.setState({ errMsg: "Please enter the number of units" });
    }
  };

  render() {
    const { basePrice, range, type } = this.props.data;
    return (
      <div>
        <section>
          <div className="popup-header">
            {PRICING_METHODS_LABELS[type]} for {this.props.productName}
          </div>
        </section>
        <section>
          <div className="dealtable-baseprice">
            <div className="pricing-options-matrixtitle">Base Price</div>
            <Input
              className="pricing-options-input readonly-input form-control"
              disabled
              placeholder="Enter Base Price"
              readOnly
              value={basePrice}
            />
          </div>
        </section>
        <section>
          <div>
            <span className="aggridpricematrix-range-title">
              Range (in number of {this.props.qtyUom})
            </span>
            <span className="aggridpricematrix-unit-range">
              {type === PRICING_METHODS.STEP_TIER_PRICING
                ? "Price per range"
                : "Price per unit"}
            </span>
          </div>
          <div>
            {range.map((price, index) => (
              <PriceMatrixRow
                currencySymbol={this.props.currencySymbol}
                data={price}
                index={index}
                key={price.min}
                readOnly
                totalEntries={range.length - 1}
              />
            ))}
          </div>
        </section>
        {!this.props.isLocked && (
          <Fragment>
            <section>
              <div>
                <PricingPreview
                  currencySymbol={this.props.currencySymbol}
                  data={this.props.data}
                  onChange={this._onChange}
                  readOnly={false}
                  data-test="aggridpricematrix-pricingpreview"
                />
              </div>
              {this.state.errMsg && (
                <div className="error-message-wrapper">
                  <span className="error-message-icon">
                    <FontAwesomeIcon icon={["far", "times-circle"]} />
                  </span>
                  {this.state.errMsg}
                </div>
              )}
            </section>
            <section>
              <div className="popup-footer">
                <div className="addgridcolumn-footer-actions">
                  <Button
                    data-test="price-submit-button"
                    className="btn btn-primary"
                    onClick={this._onSubmit}>
                    Submit
                  </Button>
                </div>
              </div>
            </section>
          </Fragment>
        )}
      </div>
    );
  }
}
const mapDispatchToProps = {};

export default connect(
  null,
  mapDispatchToProps,
)(AgGridPriceMatrix);



// WEBPACK FOOTER //
// ./src/components/AgGridPriceMatrix/AgGridPriceMatrix.js